
    export default {
        name: "AppFooter"
    }
